import React from "react";
import styles from "./LoaderCircle.module.scss";

interface LoaderCircleProps {
  style?: React.CSSProperties;
}

const LoaderCircle: React.FC<LoaderCircleProps> = ({ style }) => {
  return (
    <div className={styles.loaderContainer} style={style}>
      <div className={styles.loader} />
    </div>
  );
};

export default LoaderCircle;
